import { useLanguage } from "../i18n/LanguageContext";
import { IMAGES } from "../content/siteContent";
import { Reveal, Overline } from "./Reveal";
import { IconCheck } from "./Icons";

const IntroSection = () => {
    const { t } = useLanguage();
    return (
        <section className="py-12 md:py-20" aria-labelledby="intro-title" data-testid="intro-section">
            <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:gap-20 lg:px-8">
                <Reveal className="relative order-2 lg:order-1">
                    <div aria-hidden="true" className="absolute -inset-3 rounded-[2.2rem] rounded-ss-none border border-pine/15 sm:-inset-4" />
                    <div className="relative overflow-hidden rounded-[2rem] rounded-ss-none shadow-[0_30px_60px_-30px_rgba(0,77,77,0.4)]">
                        <img
                            src={IMAGES.intro}
                            alt={t.intro.imageAlt}
                            width="940"
                            height="700"
                            loading="lazy"
                            className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-[1.03]"
                        />
                    </div>
                </Reveal>
                <div className="order-1 lg:order-2">
                    <Reveal>
                        <Overline>{t.intro.overline}</Overline>
                        <h2 id="intro-title" className="mt-4 font-display text-3xl font-bold tracking-tight text-ink sm:text-4xl lg:text-5xl">
                            {t.intro.title}
                        </h2>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <p className="mt-6 text-base leading-relaxed text-mist md:text-lg">{t.intro.p1}</p>
                        <p className="mt-4 text-base leading-relaxed text-mist">{t.intro.p2}</p>
                    </Reveal>
                    <Reveal delay={0.18}>
                        <ul className="mt-8 space-y-3">
                            {t.intro.bullets.map((b) => (
                                <li key={b} className="flex items-center gap-3 text-base font-medium text-ink">
                                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-gold-100 text-gold-600">
                                        <IconCheck className="h-4 w-4" />
                                    </span>
                                    {b}
                                </li>
                            ))}
                        </ul>
                    </Reveal>
                </div>
            </div>
        </section>
    );
};

export default IntroSection;
